var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 12,
    fill: "#4B9BF5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0913 12.7952H24.9998V14.7273H27.1252V18.3662C27.1252 21.5623 24.5248 24.1627 21.3287 24.1627C18.1326 24.1627 15.5322 21.5624 15.5322 18.3663V14.7273H17.5932V12.7952H14.5662C14.0326 12.7952 13.6001 13.2277 13.6001 13.7613V18.3663C13.6001 22.628 17.067 26.0949 21.3287 26.0949C25.5904 26.0949 29.0574 22.628 29.0574 18.3663V13.7613C29.0574 13.2277 28.6249 12.7952 28.0913 12.7952Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8596 26.8999V31.4727C31.8596 34.1362 29.6927 36.3031 27.0292 36.3031C24.3657 36.3031 22.1987 34.1362 22.1987 31.4727V25.161H20.2666V31.4727C20.2666 35.2015 23.3001 38.2353 27.0292 38.2353C30.7579 38.2353 33.7917 35.2015 33.7917 31.4727V26.8999H31.8596Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8258 20.6526C30.8544 20.6526 29.251 22.256 29.251 24.2271C29.251 26.198 30.8544 27.8016 32.8255 27.8016C34.7966 27.8016 36.4 26.198 36.4003 24.2271C36.4003 22.256 34.7966 20.6526 32.8258 20.6526ZM32.8255 25.8695C31.9196 25.8695 31.1828 25.1327 31.1828 24.2272C31.1828 23.3217 31.9196 22.5849 32.8255 22.5849C33.731 22.5849 34.4678 23.3217 34.4678 24.2272C34.4678 25.1327 33.731 25.8695 32.8255 25.8695Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5613 11.7647C17.0277 11.7647 16.5952 12.1972 16.5952 12.7308V14.7918C16.5952 15.3254 17.0277 15.7578 17.5613 15.7578C18.0949 15.7578 18.5274 15.3254 18.5274 14.7918V12.7308C18.5274 12.1972 18.0949 11.7647 17.5613 11.7647Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0325 11.7647C24.4989 11.7647 24.0664 12.1972 24.0664 12.7308V14.7918C24.0664 15.3254 24.4989 15.7578 25.0325 15.7578C25.5661 15.7578 25.9985 15.3254 25.9985 14.7918V12.7308C25.9985 12.1972 25.5661 11.7647 25.0325 11.7647Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.4706,
    height: 26.4706,
    fill: "white",
    transform: "translate(11.7646 11.7647)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecIcon);
export default __webpack_public_path__ + "static/media/spec-icon.9f0e3c8dba123c24711342916e52060e.svg";
export { ForwardRef as ReactComponent };